import reduxCrud from 'redux-crud';

const demandsActionCreators = reduxCrud.actionCreatorsFor('demands', {
  key: 'id',
});
const actionTypes = reduxCrud.actionTypesFor('demands', { key: 'id' });

export default demandsActionCreators;
export { actionTypes };
